import { Component, OnInit } from '@angular/core';
import { TranslationService } from '@lciapps/lci-core';

@Component({
  selector: 'app-activities-disclaimer',
  templateUrl: './activities-disclaimer.component.html',
  styleUrls: ['./activities-disclaimer.component.scss']
})
export class ActivitiesDisclaimerComponent implements OnInit {
  lblDetails = 'Details';

  constructor(
    private translationService: TranslationService
  ) {

  }

  ngOnInit() {
    this.translationService
      .getTranslationValue('lbltDetails')
      .subscribe((res) => {
        this.lblDetails = res;
      });
  }

}
